var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('div',{staticClass:"jsoneditor-container"}),(_vm.showBtns)?_c('div',{staticClass:"jsoneditor-btns"},[_c('el-button',{attrs:{"type":"primary","disabled":_vm.error},on:{"click":_vm.onSubmit}},[_vm._v("确定")])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }